import { connectionDefinitions } from 'graphql-relay';

import NotificationType from '../gqlTypes/notification.gql.js';

const { connectionType } = connectionDefinitions({ nodeType: NotificationType });

export default connectionType;
